import logger from './logger';
let scorer;
let pending;
/**
 * The zxcvbn scorer behind the insecure-room-name warning, loaded on demand.
 *
 * zxcvbn is ~800 KiB of word lists (about a sixth of the main bundle) and the
 * warning is off unless `enableInsecureRoomNameWarning` is set, so it ships as
 * its own chunk. The first check starts the download and reports "not ready";
 * callers re-evaluate on their next render and see the loaded scorer. A failed
 * download shows no warning and is retried on the next check.
 *
 * @returns {RoomNameScorer|undefined} The scorer once loaded.
 */
export function getRoomNameScorer() {
    if (!scorer && !pending) {
        pending = import(/* webpackChunkName: "zxcvbn" */ 'zxcvbn')
            .then(module => {
            scorer = module.default;
        })
            .catch(error => {
            pending = undefined;
            logger.warn('Room name strength checker failed to load', error);
        });
    }
    return scorer;
}
